import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhone = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 8,
	viewBox: "0 0 22 8",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11 0C16.799 0 21.5 1.92862 21.5 4.30769V6.66667C21.5 7.40305 20.903 8 20.1667 8H16.0392C15.3521 8 14.7864 7.48027 14.7138 6.8125H14.75V4.9375C14.75 4.24714 13.0711 3.6875 11 3.6875C8.92893 3.6875 7.25 4.24714 7.25 4.9375L7.25 4.93877V6.8125H7.28623C7.21359 7.48027 6.64788 8 5.96078 8H1.83333C1.09695 8 0.5 7.40305 0.5 6.66667V4.30769C0.5 1.92862 5.20101 0 11 0Z",
		fill: "current"
	})]
});
const ForwardRef = forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
